import { handleJSON, stringifyParams } from '@/utils/fetch-utils';
import { headers } from './index';

const { API_URL } = process.env;

let abortController = new AbortController();

export default {
  endpoints: {
    lessonsList: query => `${API_URL}/resources/${query}`,
    tagsList: `${API_URL}/tags/`,
    shareLesson: `${API_URL}/assignments/`,
    cancelLesson: assignmentId => `${API_URL}/assignments/${assignmentId}/cancel/`,
    shareHistory: (userId, query) => `${API_URL}/assignments/assigner/${userId}/${query}`,
  },

  fetchLessonsList(params) {
    abortController.abort();
    abortController = new AbortController();

    const options = {
      method: 'GET',
      headers: headers(),
      signal: abortController.signal,
    };

    const query = stringifyParams(params);
    const endpoint = this.endpoints.lessonsList(query);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchLessonsTagsList() {
    const options = {
      method: 'GET',
      headers: headers(),
    };
    const endpoint = this.endpoints.tagsList;

    return fetch(endpoint, options).then(handleJSON);
  },

  shareLesson(body) {
    const options = {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(body),
    };

    const endpoint = this.endpoints.shareLesson;

    return fetch(endpoint, options).then(handleJSON);
  },

  async cancelSharedLesson(assignmentId) {
    const options = {
      method: 'POST',
      headers: headers(),
    };
    const endpoint = this.endpoints.cancelLesson(assignmentId);

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchShareHistory(userId, params) {
    const options = {
      method: 'GET',
      headers: headers(),
    };

    const query = stringifyParams(params);
    const endpoint = this.endpoints.shareHistory(userId, query);

    return fetch(endpoint, options).then(handleJSON);
  },
};
